import { render, staticRenderFns } from "./DomainMonitor.vue?vue&type=template&id=718f5aa2&scoped=true&"
import script from "./DomainMonitor.vue?vue&type=script&lang=js&"
export * from "./DomainMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DomainMonitor.vue?vue&type=style&index=0&id=718f5aa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f5aa2",
  null
  
)

export default component.exports